import styled from "styled-components";

// export const StyledNavbar = styled.nav`
//   position: fixed;
//   top: 0;
//   width: 100%;
//   height: var(--nav-height);
//   display: flex;
//   align-items: center;
//   justify-content: flex-end;

//   background-color: var(--burgundy-85);
//   backdrop-filter: blur(10px);
//   z-index: 101;
//   padding: 0 50px;
//   transition: background-color 0.001s ease-in-out,
//     backdrop-filter 0.001s ease-in-out;

//   @media (max-width: 768px) {
//     padding: 0 20px;
//     ${({ $open }) =>
//       $open &&
//       `
//       background-color: transparent;
//       backdrop-filter: none;
//       box-shadow: none;
//       `}
//   }
// `;

export const StyledNavbar = styled.nav`
  position: fixed;
  top: 0;
  width: 100%;
  height: var(--nav-height);
  display: flex;
  align-items: center;
  justify-content: flex-end;

  background-color: rgba(74, 26, 43, 0.85); /* Better fallback than var */
  backdrop-filter: blur(10px);

  z-index: 101;
  padding: 0 50px;

  /* REMOVE transitions on load */
  transition: none;

  @media (max-width: 768px) {
    padding: 0 20px;

    ${({ $open }) =>
      $open &&
      `
      background-color: transparent;
      backdrop-filter: none;
      box-shadow: none;
      transition: background-color 0.3s ease-in-out, backdrop-filter 0.3s ease-in-out;
    `}
  }
`;

export const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;

  background-color: var(--dark-50);
  backdrop-filter: blur(5px);
  z-index: 99;
  display: ${({ $open }) => ($open ? "block" : "none")};
  transition: opacity 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
  pointer-events: none;
  user-select: none;
`;

export const StyledLinks = styled.div`
  display: flex;
  align-items: center;

  ul {
    ${({ theme }) => theme.mixins.flexBetween};
    padding: 0;
    margin: 0;
    list-style: none;

    @media (max-width: 768px) {
      position: fixed;
      top: 0;
      right: 0;
      height: 100vh;
      width: min(75vw, 400px);
      background-color: var(--burgundy-95);
      flex-direction: column;
      align-items: center;
      justify-content: center;
      transform: translateX(100%);
      opacity: 0;
      visibility: hidden;
      transition: transform 0.5s ease-in-out, opacity 0.4s ease-in-out,
        visibility 0s linear 0.5s;

      ${({ $open }) =>
        $open &&
        `
      transform: translateX(0);
      opacity: 1;
      visibility: visible;
      transition: transform 0.5s ease-in-out, opacity 0.4s ease-in-out;
    `}
    }

    li {
      margin: 0 5px;
      position: relative;
      counter-increment: item 1;
      font-size: var(--fz-lg);

      @media (max-width: 768px) {
        font-size: var(--fz-xl);
        margin: 20px 0;
      }

      a {
        padding: 10px;
        cursor: pointer;
        color: var(--teal);
        transition: var(--transition);

        @media (max-width: 768px) {
          padding: 18px 50px;
        }
      }

      &::after {
        content: "";
        position: absolute;
        left: 10px;
        bottom: -2px;
        width: 0;
        height: 2px;
        background-color: var(--teal);
        transition: var(--transition);
      }

      &:hover,
      &:focus {
        color: var(--teal);

        &::after {
          width: calc(100% - 18px);
        }
      }
    }
  }

  div {
    display: flex;
  }

  .resume-button {
    ${({ theme }) => theme.mixins.smallButton};
    margin-left: 15px;
    font-size: var(--fz-lg);

    @media (max-width: 768px) {
      display: none;
    }
  }
`;

export const Hamburger = styled.div`
  position: fixed;
  top: 20px;
  right: 20px;
  width: 30px;
  height: 24px;
  display: none;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
  z-index: 150;

  span {
    display: block;
    height: 4px;
    width: 100%;
    background-color: var(--teal-90);
    transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
  }

  ${({ $open }) =>
    $open
      ? `
        span:nth-child(1) {
          transform: rotate(45deg) translate(7px, 7px);
        }
        span:nth-child(2) {
          opacity: 0;
        }
        span:nth-child(3) {
          transform: rotate(-45deg) translate(7px, -7px);
        }
      `
      : `
        span:nth-child(1) {
          transform: rotate(0);
        }
        span:nth-child(2) {
          opacity: 1;
        }
        span:nth-child(3) {
          transform: rotate(0);
        }
      `}

  @media (max-width: 768px) {
    display: flex;
  }
`;

export const ResumeButton = styled.a`
  display: none;

  @media (max-width: 768px) {
    display: flex;
    border: 1px solid var(--teal);
    color: var(--teal);
    font-size: var(--fz-xl);
    text-decoration: none;
    border-radius: var(--border-radius);
    width: max-content;
  }
`;

// export const StyledNavLinks = styled.ul`
//   list-style: none;
//   padding: 0;
//   margin: 0;
//   display: flex;
//   margin-left: auto;

//   @media (max-width: 768px) {
//     position: fixed;
//     top: 0;
//     right: 0;
//     height: 100vh;
//     width: min(75vw, 400px);
//     background-color: var(--burgundy-95);
//     flex-direction: column;
//     align-items: center;
//     justify-content: center;
//     transform: translateX(100%);
//     opacity: 0;
//     visibility: hidden;
//     transition: transform 0.5s ease-in-out, opacity 0.4s ease-in-out,
//       visibility 0s linear 0.5s;

//     ${({ $open }) =>
//       $open &&
//       `
//       transform: translateX(0);
//       opacity: 1;
//       visibility: visible;
//       transition: transform 0.5s ease-in-out, opacity 0.4s ease-in-out;
//     `}
//   }

//   li {
//     margin: 0 20px;
//     font-size: var(--fz-lg);
//     text-transform: uppercase;
//     letter-spacing: 1px;
//     font-weight: 500;

//     @media (max-width: 768px) {
//       margin: 20px 0;
//       font-size: var(--fz-lg);
//     }
//   }

//   a {
//     text-decoration: none;
//     color: var(--teal);
//     font-size: var(--fz-lg);
//     // transition: color 0.3s ease-in-out;
//     transition: var(--transition);

//     &:hover {
//       color: var(--teal);
//       cursor: pointer;
//     }
//   }
// `;

// // ${({ theme }) => theme.mixins.smallButton};
// export const ResumeButton = styled.a`
//   // padding: 8px 16px;
//   // border: 1px solid var(--teal-90);
//   // color: var(--teal-90);
//   // font-size: var(--fz-sm);
//   // font-weight: 500;
//   // text-decoration: none;
//   // border-radius: 4px;
//   // transition: all 0.3s ease-in-out;

//   color: var(--teal);
//   background-color: transparent;
//   border: 1px solid var(--teal);
//   border-radius: var(--border-radius);
//   padding: 0.75rem 1rem;
//   line-height: 1;
//   text-decoration: none;
//   // transition: var(--transition);
//   transform: translate(-4px, -4px);
//   margin-left: 15px;
//   font-size: var(--fz-xs);

//   &:hover {
//     // background-color: var(--teal-20);
//     // color: var(--teal);
//     outline: none;
//     box-shadow: 3px 3px 0 0 var(--teal);
//     transition: var(--transition);
//     // transform: translate(-4px, -4px);
//   }
// `;
